/**
 * Checks if the current date is within the Christmas period
 * (December 15 - January 1st)
 * @returns {boolean} True if current date is between December 15 and January 1st
 */
export const isChristmasPeriod = (): boolean => {
  const now = new Date();
  const month = now.getMonth(); // 0-11 (0 = January, 11 = December)
  const day = now.getDate();

  // December 15-31
  if (month === 11 && day >= 15) {
    return true;
  }
  // January 1st
  if (month === 0 && day === 1) {
    return true;
  }

  return false;
};
